export enum EventsType {
  CC_WEBCHAT_BOOT = 'CC_WEBCHAT_BOOT',
  CC_WEBCHAT_INITIALIZED = 'CC_WEBCHAT_INITIALIZED',
  CC_WEBCHAT_SET_IFRAME_SIZE = 'CC_WEBCHAT_SET_IFRAME_SIZE',
}

export interface WindowMessageEvent {
  type: EventsType;
  payload: any;
}
